/* Decorative homepage motion. Commerce remains native and content stays visible
   without JavaScript. GSAP/ScrollTrigger 3.15.0 are pinned local assets. */
(() => {
  'use strict';
  const { gsap, ScrollTrigger } = window;
  if (!gsap || !ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);
  let media;
  const stop = () => {
    media?.revert();
    media = undefined;
  };
  const start = () => {
    stop();
    if (window.Shopify?.designMode || navigator.connection?.saveData || document.hidden) return;
    const home = document.querySelector('[data-utique-home]');
    if (!home) return;
    media = gsap.matchMedia();
    try {
      media.add({ motion: '(prefers-reduced-motion: no-preference)', desktop: '(min-width: 750px)' }, (context) => {
        if (!context.conditions.motion) return;
        // Hierarchy: a small entrance guides the eye from headline to collection.
        const copy = home.querySelector('.utique-hero__copy');
        if (copy && home.getBoundingClientRect().bottom > 0) {
          gsap.fromTo(copy.children, { y: 16 }, { y: 0, duration: .9, stagger: .08, ease: 'power3.out', clearProps: 'transform' });
        }
        // Reveal only content still below the fold. No CSS visibility dependency.
        document.querySelectorAll('[data-utique-reveal]').forEach((element) => {
          if (element.closest('.utique-hero') || element.getBoundingClientRect().top < window.innerHeight * .92) return;
          gsap.from(element, {
            y: 28, opacity: .15, duration: .9, ease: 'power2.out', clearProps: 'transform,opacity',
            scrollTrigger: { trigger: element, start: 'top 93%', once: true },
          });
        });
        // One atmosphere continues across the homepage. Only faint true-alpha
        // side ornaments move; no scene resets at section boundaries.
        const ambient = document.querySelector('[data-utique-ambient]');
        const canvas = ambient?.closest('.utique-home-canvas');
        const glass = ambient?.querySelector('[data-utique-ambient-glass]');
        const veil = ambient?.querySelector('[data-utique-ambient-veil]');
        if (!canvas || !glass || !veil) return;
        const distance = context.conditions.desktop ? 1 : .55;
        const timeline = gsap.timeline({
          defaults: { ease: 'none' },
          scrollTrigger: { trigger: canvas, start: 'top top', end: 'bottom bottom', scrub: .7, invalidateOnRefresh: true },
        });
        timeline.fromTo(glass,
          { x: -12 * distance, y: -35 * distance, rotation: -5, opacity: .24 },
          { x: 24 * distance, y: 95 * distance, rotation: 7, opacity: .3, duration: .5 }, 0)
          .to(glass, { x: -8 * distance, y: -55 * distance, rotation: -2, opacity: .22, duration: .5 }, .5);
        timeline.fromTo(veil,
          { x: 14 * distance, y: 70 * distance, rotation: 6, opacity: .16 },
          { x: -20 * distance, y: -50 * distance, rotation: -6, opacity: .22, duration: .5 }, 0)
          .to(veil, { x: 16 * distance, y: -95 * distance, rotation: 3, opacity: .16, duration: .5 }, .5);
      });
    } catch {
      // Context restoration also removes partially staged entrance styles.
      stop();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', stop);
  document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', start);
  window.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
})();
